class MessagePublishSubscribe {
	events: any
	constructor(){
		this.events = {}
	}

	// on logic can be leveraged to fulfill subscribe
	subscribe = (event: any, handler: (e:any)=>void): void => {
		if(!this.events[event]){
			this.events[event] = []
		}
		this.events[event].push(handler)
	}

	//off logic can be leveraged to fulfill unsubscribe
	unsubscribe(event:any, handler:any){
		if(this.events[event]){
			const index = this.events[event].findIndex((item:any) => item === handler)
			this.events[event].splice(index, 1);
		}
	}

	//emit logic can be leveraged to fulfill unsubscribe
	publish(event:any, data:any){
		if(this.events[event]){
			this.events[event].forEach((handler:any) => handler(data));
		}
	}
}

export default MessagePublishSubscribe;